import { css, html, LitElement, PropertyValues, TemplateResult } from "lit";
import {property, customElement} from 'lit/decorators.js';
import { FiSubView, UiStateModel, UiStateModelParam } from "../../../src/models/ui-state-model";
import { VoyageShoreContextModel } from "../../../src/models/voyage-shore-context-model";
import { SvgIcons } from "../../voyage-svg-icons/src/voyage-svg-icons";
import "../../voyage-button/src/voyage-button";
import "../../voy-fleet-alarms/src/voy-fleet-alarms-list";
import "../../voy-handle-alarm-popup/src/voy-handle-alarm-popup";
import "../../voyage-spinner/src/voyage-spinner";
import { AlarmState } from "../../../src/services/types/fleet-alarms-service.types";
import { FleetAlarm } from "../../../src/models/types/voy-fleet-alarm-model.types";
import { VoyFleetAlarmModel } from "../../../src/models/voy-fleet-alarm-model";
import { VesselInfo } from "../../../src/models/types/vessels-model.types";
import { VesselsModel } from "../../../src/models/vessels-model";
import { ShoreContextEvent } from "../../../src/models/types/voyage-shore-context-model.types";
import { VesselVoyageVersion } from "../../voy-global-filters/src/types";

@customElement("voy-fleet-sub-view-vessel-alarms")
export class VoyFleetSubViewVesselAlarms extends LitElement {
    @property({ type: Number }) imo?: number;
    @property({ type: Object, attribute: false}) private _vessel?: VesselInfo;
    @property({ attribute: false }) private _alarms?: FleetAlarm[];
    @property({ attribute: false }) private _maximized: boolean = false;
    @property({ type: Boolean, attribute: false }) private _loader: boolean = false;
    @property({ type: Boolean, attribute: false }) private _version?: string;
    @property({ type:Boolean }) private  _timeLineVisible : any =  false

    constructor() {
        super()

        this._goToSubView = this._goToSubView.bind(this);
        this._setVessel = this._setVessel.bind(this);
        this._toggleMaximizedCharts = this._toggleMaximizedCharts.bind(this)
        this._getAlarmForCurrentVessel = this._getAlarmForCurrentVessel.bind(this)
        this._renderAlarms = this._renderAlarms.bind(this)
        this._toggleTimeLine = this._toggleTimeLine.bind(this);
        if(localStorage.getItem("timeLineView")!==undefined) {
            this._timeLineVisible = localStorage.getItem("timeLineView")=="true";
        }
    }

    static styles = [
        css`
            :host {
                font-family: MaerskText;
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
                max-height: calc(100vh - 163px);
            }
            section, nav {
                display: flex;
                flex-direction: column;
                padding: 16px;
            }

            section header {
                padding: 8px 0;
            }

            h1,
            h2,
            h3 {
                margin: 0;
            }

            h1 {
                font-size: 26px;
                line-height: 32px;
                font-weight: 400;
                color: var(--neutrals-grey-02);
                font-family: MaerskHeadline;
            }
            header {
                display: flex;
                flex-direction: row;
                column-gap: 4px;
            }
            header button {
                background: none;
                border: none;
                margin-top: 6px;
                cursor: pointer;
                padding: 0;
                display: flex;
                margin-left: -6px;
            }
            nav {
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                border-top: 1px solid var(--neutrals-grey-06);
                border-bottom: 1px solid var(--neutrals-grey-06);
                box-shadow: var(--voyage-box-shadow) 0px 6px 10px;
                position: relative;
                z-index: 1;
            }
            nav button {
                font-family: MaerskText;
                display: inline-block;
                column-gap: 8px;
                align-items: center;
                background: none;
                color: var(--voyage-blue-dark);
                border: none;
                text-align: left;
                cursor: pointer;
                padding: 0;
                margin: 0 10px 0 0;
            }
            section:nth-of-type(2) {
                /* max-height: calc(100vh - 327px); */
                overflow: auto;
                position: relative;
            }

            .alarm h2 {
                font-size: 16px;
                line-height: 24px;
            }

            .alarm h3 {
                font-size: 12px;
                line-height: 16px;
            }

            .alarm .row {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            voy-timeseries-chart {
                width: 100%;
                height: 150px;
            }

            #no-data {
                row-gap: 0px;
                padding: 24px 16px;
            }

            #no-data p {
                margin-bottom: 0;
            }

            #no-data span {
                color: var(--voyage-blue-dark);
                cursor: pointer;
            }
            .chart-container {
                background-color: var(--neutrals-grey-10);
                padding: 0;
                max-height: calc(100vh - 327px);
            }
            .chart-conatiner-full {
                max-height: calc(100vh - 272px);
            }

            .chart-container[maximized] {
                width: 100%;
                position: fixed;
                bottom: 56px;
                height: fit-content;
                margin-top: 0px;
                box-shadow: var(--voyage-box-shadow) 0px 6px 10px;
                z-index: 2;
            }
            .expand-container {
                margin-left: calc(100% - 15px);
                height: 20px;
                width: 20px;
                background-color: var(--neutrals-grey-10);
                z-index: 10;
                cursor: pointer;
                position: absolute;
                right: 16px;
                top: 16px;
                }
            .expand-container > svg {
                fill: var(--neutrals-grey-02, black);
            }
            .chart-container[maximized] .alarms-section .data-container{
                display: flex;
                flex-direction: flex-row;
                background-color: red;
            }
            .loadingOverlay {
                position: absolute;
                top: -1px;
                bottom: -1px;
                right: -1px;
                left: -1px;
                z-index: 10;
                border-radius: 3px;
            }

            voyage-spinner {
                width: 50px;
                height: 50px;
                left: calc(50% - 25px);
                top: calc(50% - 25px);
                position: absolute;
            }
            .spinner-wrapper{
                position: relative;
                height: 100px;
                width: 100%;
                background-color: var(--neutrals-grey-10);
            }
            .premium-icon svg{
                height: 16px;
                width: 16px;
            }
        `
    ]

    render() {
        const isPremium:boolean = this._vessel?.vesselVersion === VesselVoyageVersion.Premium;
        return html`
            <section>
                <header>
                    <button @click=${() => this._goToSubView(FiSubView.VesselDetails)} data-test="back-button">${SvgIcons.customChevronLeft}</button>
                    <h1><span class="premium-icon" ?hidden=${!isPremium}>${SvgIcons.customPremiumVessel}</span>${this._vessel?.vesselName || "N/A"}<br>Alarms</h1>
                </header>
            </section>
            <nav>
                <button @click=${() => this._goToSubView(FiSubView.VesselAlarmsLog)}>Alarm log</button>
                <button @click=${() => this._goToSubView(FiSubView.VesselNotificationsLog)}>Notification log</button>
            </nav>
            ${this._renderAlarms()}
        `
    }

    firstUpdated() {
        this._setVessel();
        this._getAlarmForCurrentVessel();
    }

    update(changedProperties: PropertyValues) {
        
        if (changedProperties.has('imo')) {
            this._setVessel();
        }

        if(changedProperties.has('_alarms')){
            this.requestUpdate()
        }

        super.update(changedProperties);
    }

    connectedCallback() {
        super.connectedCallback();

        UiStateModel!.addEventListener(`${UiStateModelParam.IMO}-change`, this._setVessel);
        VoyFleetAlarmModel!.addEventListener('alarms-updated', this._getAlarmForCurrentVessel);
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        UiStateModel!.removeEventListener(`${UiStateModelParam.IMO}-change`, this._setVessel);
        VoyFleetAlarmModel!.removeEventListener('alarms-updated', this._getAlarmForCurrentVessel);
        VoyageShoreContextModel!.removeEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);

    }
    
    private async _getAlarmForCurrentVessel() {
        if(!this.imo) return
        this._version = this._vessel?.vesselVersion
        // handle page refresh scenarion in alarm detail page
        if(!this._version){
            await VesselsModel?.refreshVessels()
            this._vessel = VesselsModel!.getVessel(this.imo)
            this._version = this._vessel?.vesselVersion
        } 
        this._alarms = await VoyFleetAlarmModel!.getVesselAlarms(this.imo)
    }

    private _goToSubView(view: FiSubView) {
        UiStateModel!.setValue(UiStateModelParam.FISubView, view);
    }

    private _setVessel(): void {
        if (!this.imo) return;
        this._vessel = VoyageShoreContextModel!.vessels.find(v => v.imoNo === this.imo);
    }

    private _toggleMaximizedCharts() {
        this._maximized = !this._maximized;
    }

    private _renderAlarms():TemplateResult {
        let className = this._timeLineVisible ? "chart-container" : "chart-container chart-conatiner-full"

        if(this._alarms === undefined) {
            return html`
            <div class="spinner-wrapper">
                <div class="loadingOverlay">
                    <voyage-spinner></voyage-spinner>
                </div>
            </div>` 
        }

        const activeAlarms = this._alarms.filter(alarm => alarm.alarmState === AlarmState.Active || alarm.alarmState === AlarmState.InProgress)

        if(activeAlarms.length <= 0 ){
            return html` 
                <section id="no-data">
                    <h2>Everything is OK!</h2>
                    <p>There are no alarms for the current voyage. To see previous and handled alarms, view the <span @click=${() => this._goToSubView(FiSubView.VesselAlarmsLog)}>Alarm log</span></p>
                </section>
            `
        } 

        return html`
            <section class=${className} ?maximized=${this._maximized}>
                <div class="expand-container" title="${this._maximized ? 'Minimize performance charts' : 'Maximize performance charts'}" @click=${this._toggleMaximizedCharts}>
                    ${this._maximized ? SvgIcons.solidCompressArrowsAlt : SvgIcons.expandPageIcon}
                </div>
                <div class="alarms-section">
                    <voy-fleet-alarms-list .maximized=${this._maximized} .alarms=${activeAlarms} .imo=${this.imo} .vesselVersion=${this._version}></voy-fleet-alarms-list>
                </div>
            </section>
        `
    }

    private _toggleTimeLine():void {
        this._timeLineVisible = !this._timeLineVisible
    }
}
